export default {
  // Update me with user
  updateMe(state, data) {
    state.me = data;
  },
  // updateActiveWebsite() {
  //   state.me
  // },
  // Clear me by setting object to empty
  clearMe(state) {
    state.me = {};
  },
};
